// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__2XP5d","paramInput":"JobSimulator_paramInput__2xJwg","input":"JobSimulator_input__DTiFu"};